const access_list = {
  "notification_section": {
    "profile": [ "permissionModerator", "permissionNotifications"]
  },
  "device_section": {
    "profile": ["permissionModerator", "viewDeviceProfile"],
    "ssh" : ["runDeviceSsh"]
  },
  "dashboard": ["viewDashboard"]
}

export default {
  access_list,
  prove: function (permissions, name, params) {
    return !this.denied(permissions, name, params)
  },

  denied: function (permissions, name, params) {

    if (name.indexOf('id') > -1) return false // пропускать переход в блоки и секции, где есть id

    let check_name = { block: name }
    if (Object.keys(params).length > 0){
      check_name.section = params[name]
    }

    if (Object.keys(access_list).includes(check_name.block)){
      if (!check_name.section){
        for (let access of access_list[check_name.block]) {
          if (permissions[access] && typeof(permissions[access]) !== 'undefined'){
            return false
          }
        }
        return true
      }else{
        if (Object.keys(access_list[check_name.block]).includes(check_name.section)){
          for (let access of access_list[check_name.block][check_name.section]) {
            if (permissions[access] && typeof(permissions[access]) !== 'undefined'){
              return false
            }
          }
          return true
        }
      }
    }
    return false // Затычка, чтобы пропускала туда куда мы сами доступ не прописали
  }
}
